import { EStorageKeys } from '@my-backoffice/app/shared/models/enums/storage-keys.enum';
import { StorageService } from '@my-backoffice/app/shared/services/storage-services/storage.service';

/**
 * @param {StorageService} storageService - Application session storage service.
 * @returns {boolean} True when both user id and user data exist in sessionStorage.
 */
export function hasUserDataInSession(storageService: StorageService): boolean {
  const userIdInSession = storageService.getItem(EStorageKeys.USER_ID);
  const userDataInSession = storageService.getItem(EStorageKeys.USER_DATA);

  return !!userIdInSession && !!userDataInSession;
}
